import { useMemo, useState } from 'react';
import Sidebar from './Sidebar';
import EndpointDetail from './EndpointDetail';
import Overview from './Overview';
import { getStoredUsername, logout } from '../utils/auth';

export default function Docs({ catalog, onLogout }) {
  const [activeId, setActiveId] = useState(null);
  const [search, setSearch] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const username = getStoredUsername();

  const activeEndpoint = useMemo(() => {
    if (!activeId) return null;
    for (const group of catalog) {
      const found = group.endpoints.find((ep) => ep.id === activeId);
      if (found) return found;
    }
    return null;
  }, [activeId, catalog]);

  function selectEndpoint(id) {
    setActiveId(id);
    setSidebarOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function handleLogout() {
    logout();
    onLogout();
  }

  return (
    <div className="docs-app">
      <header className="topbar">
        <button
          type="button"
          className="sidebar-toggle"
          onClick={() => setSidebarOpen((o) => !o)}
          aria-label="Toggle navigation"
        >
          &#9776;
        </button>
        <button type="button" className="topbar-brand" onClick={() => setActiveId(null)}>
          <img src="/definitelogo.png" alt="Definite Assurance" />
          <span>
            Definite Assurance <strong>API Docs</strong>
          </span>
        </button>
        <div className="topbar-spacer" />
        {username && <span className="topbar-user">Signed in as {username}</span>}
        <button type="button" className="topbar-logout" onClick={handleLogout}>
          Log out
        </button>
      </header>

      <div className="docs-body">
        <Sidebar
          catalog={catalog}
          activeId={activeId}
          onSelect={selectEndpoint}
          search={search}
          onSearchChange={setSearch}
          isOpen={sidebarOpen}
        />
        {sidebarOpen && (
          <button
            type="button"
            className="sidebar-scrim"
            aria-label="Close navigation"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <main className="docs-content">
          {activeEndpoint ? (
            <EndpointDetail endpoint={activeEndpoint} />
          ) : (
            <Overview catalog={catalog} onSelect={selectEndpoint} />
          )}
        </main>
      </div>
    </div>
  );
}
